<template>
  <div>
    <div class="title title-mb">
      <div class="title-block">
        <div class="block"></div>
        <div class="titleText">基本信息</div>
      </div>
      <div>
        <span>调拨单号：</span>
        <span>{{ }}</span>
      </div>
    </div>

    <el-form :model="formData" ref="form" :rules="rules" label-width="80px">
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <el-form-item :label="'计划名称' + (type == 'preview' ? '：' : '')">
            <el-input v-model="formData.remark" placeholder="请输入" v-if="type != 'preview'"></el-input>
            <span v-else>{{ formData.remark ? formData.remark : '-' }}</span>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="24" :xs="12">
          <el-form-item :label="'备注' + (type == 'preview' ? '：' : '')">
            <el-input
              type="textarea"
              :rows="3"
              v-model="formData.remark"
              placeholder="300字以内"
              v-if="type != 'preview'"
            ></el-input>
            <span v-else>{{ formData.remark ? formData.remark : '-' }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="title title-mb">
        <div class="title-block">
          <div class="block"></div>
          <div class="titleText">计划信息</div>
          <el-button class="line-button" icon="el-icon-plus" @click="addrow">新增行</el-button>
        </div>
      </div>

      <TablePublic :colLists="colLists" :tableData="tableData">
        <template slot="solts" slot-scope="scope">
          <el-button
            class="button"
            type="text"
            size="small"
            @click="handleDel(scope.data, scope.$index)"
          >删除</el-button>
        </template>
        <template slot="code" slot-scope="scope">
          <el-input v-model="scope.data.code"></el-input>
        </template>
        <template slot="oilCode" slot-scope="scope">
          <el-input v-model="scope.data.oilCode"></el-input>
        </template>
        <template slot="createTime" slot-scope="scope">
          <el-input v-model="scope.data.createTime"></el-input>
        </template>
      </TablePublic>

      <div class="attachment-info">
        <div class="title title-mt title-mb">
          <div class="title-block">
            <div class="block"></div>
            <div class="titleText title-mr">上传附件</div>
            <el-upload
              class="upload-demo"
              :headers="importHeaders"
              :action="uploadPath"
              accept=".jpg, .jpeg, .png, .webp, .gif, .bmp, .pdf, .dwg, .dxf, .xls, .xlsx, .doc, .docx, .txt, .mp4, .avi"
              :show-file-list="false"
              :on-change="handlePropress"
              :on-success="handleAvatarSuccess"
              :on-error="handleAvatarError"
              :before-upload="beforeAvatarUpload"
            >
              <el-button class="line-button" icon="el-icon-plus">上传附件</el-button>
            </el-upload>
          </div>
        </div>

        <Attachment
          v-if="formData.attachments && formData.attachments.length > 0"
          :fileList="formData.attachments"
          :is-examine="true"
          :isEdit="true"
          @on-del="handleDelFile"
          :showFileType="false"
        ></Attachment>
        <div v-else class="no-contract-type">暂无内容</div>
      </div>
    </el-form>
  </div>
</template>

<script>
import TablePublic from '@/components/tablePublic.vue'
import Attachment from '@/components/attachment.vue'
export default {
  components: {
    TablePublic,
    Attachment,
  },
  data() {
    return {
      importHeaders: '',
      uploadPath: '',
      colLists: [
        {
          prop: 'code',
          label: '培育方式',
          isTrue: true,
          formSolt: true,
        },
        {
          prop: 'oilCode',
          label: '成熟度',
          isTrue: true,
          formSolt: true,
        },
        {
          prop: 'createTime',
          label: '计划采购总净重(斤)',
          isTrue: true,
          formSolt: true,
        },

        {
          label: '操作',
          prop: 'address',
          align: 'center',
          solt: true,
          isTrue: true,
          width: 200,
          rightFlag: true,
        },
      ],
      formData: { attachments: [] },
      tableData: [],
    }
  },
  methods: {
    addrow() {
      this.tableData.push({
        code: 'xxx',
        oilCode: 'xxxxxx',
        createTime: '2024',
      })
    },
    beforeAvatarUpload() {},
    handleAvatarError() {},
    handlePropress() {},
    handleAvatarSuccess() {},
    handleDel() {},
    handleDelFile() {},
  },
}
</script>

<style scoped lang='less'>
@import '../../../../assets/form.less';
::v-deep {
  .no-contract-type {
    padding: 30px;
    background-color: #f8f8f8;
    border-radius: 12px;
    text-align: center;
    border: 1px solid #dde4ff;
    margin-bottom: 20px;
  }
}
</style>